import { useContext, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, useNavigation } from 'react-router-dom';
import HeaderControl from '../../features/alumni/_common/HeaderControl';
import SessionContext from '../../library/Core/SessionContext';
import ErrorPage from '../../library/SimpleControls/ErrorPage';
import PageFooterControl from '../../library/SimpleControls/PageFooterControl';
import MenuBuilder from '../../routes/MenuBuilder';
import { isSchoolAdmin, isSuperAdmin } from '../../library/Core/SmartFunctions';
import ResendVerificationEmailControl from '../../features/alumni/_common/ResendVerificationEmailControl';
import FactLoader from '../../library/SimpleControls/FactLoader';

function StandardLayout() {
    // const gUserStatusCode = useAppContext()?.getSelectedInstitute()?.userStatusCode;
    const { sessionState } = useContext(SessionContext);
    const [userStatusCode, setUserStatusCode] = useState(sessionState?.userStatusCode ?? 'INACTIVE');
    
    // @UAS-2095-start
    const enableHeader =
        (userStatusCode === 'ACTIVE' || sessionState?.profileStatusCode == 'basic-info-complete' || sessionState?.profileStatusCode == 'COMPLETE' ||
            sessionState?.userStatusCode == 'ACTIVE' ||
            sessionStorage.getItem('is-impersonated-session') === 'YES' ||
            isSchoolAdmin() || isSuperAdmin())  ??
        false;
   // const enableHeader = true;
    // @UAS-2095-end
    
    const handleUpdateUserStatusCode = () => {
        setUserStatusCode('ACTIVE');
    };

    const handleNavigateToHome = () => {
        // resetErrorBoundary();
        return <ErrorPage />;
    };

    const handleError = (error: any, errorInfo: any) => {};

    const navigation = useNavigation();

    return (
        <div className="d-flex flex-column min-vh-100">
            {enableHeader && (
                <header>
                    <HeaderControl />
                    <ResendVerificationEmailControl />
                    <MenuBuilder />
                </header>
            )}
            <FactLoader show={navigation.state === 'loading'} />
            <ErrorBoundary fallbackRender={handleNavigateToHome} onReset={(details) => {}} onError={handleError}>
                <Outlet />
            </ErrorBoundary>
            <PageFooterControl />
            {/* https://stackoverflow.com/questions/56660153/how-to-listen-to-localstorage-value-changes-in-react */}
            <button style={{ display: 'none' }} onClick={handleUpdateUserStatusCode} id="updateUserStatusCode">
                Hidden Button
            </button>
        </div>
    );
}

export default StandardLayout;
